import React from "react";
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const HandleNotFound = () => {
        navigate(-1);
    }
    return (
        <>
            <section className="content-header">
                <h1>Ooooops !!! - Not Found Page</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-9">
                                        <h4 className="panel-title">
                                            <i className="fa fa-home" aria-hidden="true"></i>
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <div className="notfound">
                                    <h2>Page Not Found</h2>
                                    <button type="button" className="btn btn-danger" onClick={HandleNotFound}>Cancel</button>
                                </div>
                            </div>
                        </div>
                        <div className="panel-footer">
                            <h4>Copyright © 2023 NDC Professionals Forum. All rights reserved.</h4>
                        </div>
                    </div>

                </div>

            </section >
        </>
    )
}

export default NotFoundPage
